import { type PayloadAction } from '@reduxjs/toolkit';
import { get } from 'lodash';

import { createSlice } from '@/lib/redux/createSlice';
import { UserService } from '@/lib/services/user';

import { initialState } from './initialState';
import type { IUser } from '@enl/type-definitions';

const slice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: (create) => {
    return {
      getMe: create.asyncThunk<IUser, void, { rejectValue: string }>(
        async () => {
          const user = await UserService.getMe();
          return user;
        },
        {
          pending: (state) => {
            state.loading = true;
          },
          options: {
            condition: (_, api) => {
              const x = api.getState();
              const isLoading = get(x, 'user.loading', false);
              return !isLoading;
            },
          },
          rejected: (state) => {
            state.loading = false;
          },
          fulfilled: (state, action: PayloadAction<IUser>) => {
            state.loading = false;
            state.data = action.payload;
          },
        }
      ),
      updateMe: create.asyncThunk<
        IUser,
        Pick<IUser, 'firstName' | 'lastName' | 'phone' | 'avatar'>,
        { rejectValue: string }
      >(
        async (payload) => {
          const user = await UserService.updateMe(payload);
          return user;
        },
        {
          pending: (state) => {
            state.loading = true;
          },
          options: {
            condition: (_, api) => {
              const x = api.getState();
              const isLoading = get(x, 'user.loading', false);
              return !isLoading;
            },
          },
          rejected: (state) => {
            state.loading = false;
          },
          fulfilled: (state, action: PayloadAction<IUser>) => {
            state.loading = false;
            state.data = action.payload;
          },
        }
      ),
    };
  },
});

export default slice;
